import { ERP_EDITIONS, useEdition } from "../context/EditionContext";

const editionOrder = ["starter", "standard", "professional", "enterprise"];
const prices = {
  starter: "Small shops / basic billing",
  standard: "Traders / distributors",
  professional: "Growing business / HR + controls",
  enterprise: "Full ERP / custom deployment",
};

export default function EditionSettingsPage() {
  const { editionKey, features } = useEdition();

  return (
    <div className="container-fluid py-2 app-small">
      <div className="edition-hero card border-0 shadow-sm mb-3 overflow-hidden">
        <div className="card-body d-flex flex-wrap justify-content-between align-items-center gap-3">
          <div>
            <div className="text-uppercase fw-bold small opacity-75">ERP Product Edition</div>
            <h4 className="mb-1 fw-bold">Edition Locked by Seller</h4>
            <div className="opacity-75">
              Client cannot change the edition from this screen. The edition is fixed in the seller build/license configuration.
            </div>
          </div>
          <span className="badge bg-light text-dark rounded-pill px-3 py-2">
            Active: {ERP_EDITIONS[editionKey]?.name}
          </span>
        </div>
      </div>

      <div className="row g-3 mb-3">
        {editionOrder.map((key) => {
          const edition = ERP_EDITIONS[key];
          const active = editionKey === key;
          return (
            <div className="col-xl-3 col-md-6" key={key}>
              <div className={`edition-card card border-0 shadow-sm text-start w-100 h-100 ${active ? "active" : ""}`}>
                <div className="card-body">
                  <div className="d-flex justify-content-between align-items-start mb-2">
                    <div className="edition-icon"><i className="bi bi-layers"></i></div>
                    {active && <span className="badge bg-success">Seller Active</span>}
                  </div>
                  <h6 className="fw-bold mb-1">{edition.name}</h6>
                  <div className="text-muted small mb-2">{prices[key]}</div>
                  <p className="small text-muted mb-0">{edition.description}</p>
                </div>
              </div>
            </div>
          );
        })}
      </div>

      <div className="card border-0 shadow-sm">
        <div className="card-header bg-white border-0 d-flex justify-content-between align-items-center py-3">
          <div>
            <strong>Visible Features for This Client</strong>
            <div className="small text-muted">Only these features are enabled in the seller-selected edition.</div>
          </div>
          <span className="badge text-bg-primary rounded-pill">{features.length} features</span>
        </div>
        <div className="card-body pt-0">
          <div className="row g-2">
            {features.map((feature) => (
              <div className="col-xl-3 col-lg-4 col-md-6" key={feature}>
                <div className="feature-pill"><i className="bi bi-check-circle-fill"></i>{feature}</div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}
